import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import { initReactI18next } from 'react-i18next'
import { apiClient } from './api/client'

const customBackend = {
    type: 'backend',
    read: async (language, namespace, callback) => {
        try {
            const response = await apiClient(`v1/core/labels/${language}`, {
                headers: {
                    locale: language,
                },
            })

            callback(null, response.data)
        } catch (error) {
            callback(error, null)
        }
    },
}

i18n.use(initReactI18next)
    .use(LanguageDetector)
    .use(customBackend)
    .init({
        fallbackLng: 'hr',
        supportedLngs: ['hr', 'sl', 'en', 'de', 'it'],
        detection: {
            order: ['localStorage', 'navigator'],
        },
        // debug: true,
        interpolation: {
            escapeValue: false,
        },
    })

export default i18n
